const initialState = {
  loading: false,
  success: false,
  error: false,
  errorMsg: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOGIN_REQUEST': {
      return {...initialState, loading: true};
    }
    case 'LOGIN_SUCCESS': {
      return {...state, success: true, loading: false};
    }
    case 'LOGIN_FAILURE': {
      return {...state, error: action.error?.errorCode, errorMsg: action.error?.errorMessage, loading: false};
    }
    case 'LOGOUT' : {
      return Object.assign({}, state);
    }
    default:
      return state;
  }
}
